import React from 'react';
import { FaSave, FaTimes, FaTrash, FaCheckCircle } from 'react-icons/fa';

const ButtonBar = ({ buttons, onButtonClick }) => {
  const getIcon = (name) => {
    switch (name) {
      case 'add':
        return <FaCheckCircle className="mr-2" />;
      case 'save':
        return <FaSave className="mr-2" />;
      case 'cancel':
        return <FaTimes className="mr-2" />;
      case 'delete':
        return <FaTrash className="mr-2" />;
      default:
        return null;
    }
  };

  const handleClick = (e, buttonName) => {
    e.preventDefault();
    onButtonClick(buttonName);
  };

  return (
    <div className="flex  flex-col space-y-2"> 
      {buttons.map((button, index) => (
        <button
          key={index}
          className={`flex items-center text-xs px-4 py-2 rounded ${button.disabled ? 'bg-gray-300' : 'bg-blue-500 text-white'}`}
          onClick={(e) => handleClick(e, button.name)}
          disabled={button.disabled}
        >
          {getIcon(button.name)}
          {button.label}
        </button>
      ))}
    </div>
  );
};

export default ButtonBar;